<template>
  <div class="hello">
    <img src="/static/wap_bd.jpg" alt="" class="bg">
    <div class="ct2">
    </div>
    <div class="ct3">
      <div class="ct3_item" v-for="(item,index) in ct3list" :key="index">
        <img :src="item.img" alt class="ct3_itemimg" />
        <div class="ct3_itemtext1">
          <div class="ct3_itemtext1a">{{item.title}}</div>
          <div class="ct3_itemtext1b">{{item.detail}}</div>
        </div>
        <div class="ct3_itemtext2">
          <div @click="install(item.installurl)" class="ct3_itemtext2a">Android</div>
          <div @click="install(item.pgurl)" class="ct3_itemtext2a">iOS</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      ct3list: [
        {
          img: "/static/2/8.png",
          title: "留学帮帮",
          detail: "轻松学习 · 轻松赚钱 ",
          installurl: "http://download.lxbb.top/lxbb.apk",
          pgurl:"https://app.26ge.net/app/?MjAyNg==",
          price: "免费"
        },
       
      ]
    };
  },
  methods: {
    install(url) {
      window.installurl = url;
      window.location.href = url;
    }
  }
};
</script>

<style scoped>
.ct3_itemtext2a {
  color: rgb(17, 133, 228);
  font-size: 24px;
  background: #dededf;
  width: 150px;
  text-align: center;
  border-radius: 40px;
  padding: 14px 0;
  margin: 10px 0;
}
.bg{
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.hello{
  background-size: contain;
  position: fixed;
  width: 100%;
  height: 100%;
}
.ct3_itemtext2b {
  color: #67656d;
  font-size: 24px;
  text-align: center;
}

.ct3_itemtext1a {
  color: #fff;
  font-size: 36px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-box-orient: vertical;
  display: -webkit-box !important;
  word-break: break-all;
}
.ct3_itemtext1b {
  font-size: 28px;
  color: #88878c;
}
.ct3_itemtext1 {
  margin-left: 20px;
  width: 380px;
}

.ct3_itemtext1 .ct3_itemtext1a:nth-of-type(1){
  color:black;
}

.ct3_itemtext1 .ct3_itemtext1a:nth-of-type(2){
  color:black;
}

.ct3_itemimg {
  width: 116px;
  height: 110px;
  border-radius: 20px;
}
.ct3_item {
  box-sizing: border-box;
  position: absolute;
  bottom: 150px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 24px;
  align-items: center;
  margin-left:25px;
}
.hello {
  color: #f5e7e7;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.ct2 img {
  width: 100% !important;
  border-radius: 10px !important;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  text-decoration: none;
  display: block;
}
.hello {
  background: #010000;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue